<template>
  <div>
    <v-toolbar flat color="white">
      <v-layout row align-center>
        <v-toolbar-title>Products</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn
          id="add_commercial_product"
          fab
          small
          depressed
          v-if="editedItem == -1"
          @click="newProduct"
          color="theme_primary_lighten1"
          dark
          class="mb-2"
        >
          <v-icon small>add</v-icon>
        </v-btn>
      </v-layout>
    </v-toolbar>
    <v-data-table
      :headers="headers"
      :items="commercialProducts"
      :pagination.sync="pagination"
      :custom-sort="customSort"
      expand
      rows-per-page-text="Products per page"
    >
      <template slot="items" slot-scope="props">
        <td
          class="text-xs-left clickable min-width-column"
          @click="edit(props.index, props.item)"
        >
          <div v-if="editedItem == props.index">
            <v-autocomplete
              id="product_categories"
              :items="product_categories"
              background-color="white"
              item-value="id"
              item-text="name"
              v-model="currentCommercialProduct.product.product_category_id"
              placeholder="select a category"
              required
              class="small-font"
            />
          </div>
          <div v-else>{{ props.item.product.product_category.name }}</div>
        </td>

        <td
          class="clickable min-width-column"
          @click="edit(props.index, props.item)"
        >
          <div v-if="editedItem == props.index">
            <v-autocomplete
              id="products"
              :items="filteredProducts()"
              background-color="white"
              item-value="id"
              item-text="name"
              v-model="currentCommercialProduct.product.id"
              placeholder="select a product"
              class="small-font"
              v-on:keyup.enter="createOrUpdateCommercialProduct"
              required
            />
          </div>
          <div v-else>{{ props.item.product.name }}</div>
        </td>

        <td
          class="text-xs-left clickable"
          @click="edit(props.index, props.item)"
        >
          <div v-if="editedItem == props.index">
            <v-autocomplete
              id="packagings"
              :items="packagings"
              background-color="white"
              item-value="id"
              item-text="name"
              :disabled="props.item.product.id == ''"
              placeholder="select the packagings"
              v-model="currentCommercialProduct.packaging_ids"
              required
              class="small-font"
              v-on:keyup.enter="createOrUpdateCommercialProduct"
              multiple
            />
          </div>
          <div v-else>
            <v-chip
              v-for="packaging in props.item.packaging_ids"
              :key="packaging"
              >{{ getNameById(packaging, "packagings") }}</v-chip
            >
          </div>
        </td>

        <td
          class="text-xs-left clickable"
          @click="edit(props.index, props.item)"
        >
          <div v-if="editedItem == props.index">
            <v-autocomplete
              id="packaging_infos"
              :items="packaging_infos"
              background-color="white"
              item-value="id"
              item-text="name"
              :disabled="props.item.product.id == ''"
              placeholder="select the packaging infos"
              v-model="currentCommercialProduct.packaging_info_ids"
              required
              class="small-font"
              v-on:keyup.enter="createOrUpdateCommercialProduct"
              multiple
            />
          </div>
          <div v-else>
            <v-chip
              v-for="packaging_info in props.item.packaging_info_ids"
              :key="packaging_info"
              >{{ getNameById(packaging_info, "packaging_infos") }}</v-chip
            >
          </div>
        </td>

        <td class="min-width clickable">
          <v-layout justify-end align-center row>
            <div v-if="editedItem === props.index">
              <v-layout row>
                <v-btn
                  id="create_or_update_commercial_product"
                  fab
                  flat
                  @click="createOrUpdateCommercialProduct"
                >
                  <v-icon color="success">done</v-icon>
                </v-btn>
                <v-btn fab flat @click="endEdit">
                  <v-icon color="error">clear</v-icon>
                </v-btn>
              </v-layout>
            </div>
            <div v-else>
              <destroyModale
                resourceName="commercial_product"
                :itemId="props.item.id"
                warningText="You are going to remove this commercial product permanently."
                :collection="commercialProducts"
              />
            </div>
          </v-layout>
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import CREATE_COMMERCIAL_PRODUCT from "../../graphql/commercial_products/create.gql";
import UPDATE_COMMERCIAL_PRODUCT from "../../graphql/commercial_products/update.gql";

export default {
  props: {
    zoneId: {
      type: String,
    },
  },
  data() {
    return {
      editedItem: -1,
      lastCategory: "",
      currentCommercialProduct: {
        id: "",
        product_category_id: "",
        product_category: {
          name: "",
        },
        product_id: "",
        product: {
          name: "",
        },
        packaging_ids: [],
        packaging_info_ids: [],
      },
      pagination: {
        sortBy: "0",
        descending: false,
        rowsPerPage: -1,
      },
      headers: [
        {
          text: "Category",
          align: "left",
          sortable: true,
          value: "0",
        },
        {
          text: "Product",
          align: "left",
          sortable: true,
          value: "1",
        },
        {
          text: "Packagings",
          align: "left",
          sortable: false,
          value: "packaging_ids",
        },
        {
          text: "Packaging Infos",
          align: "left",
          sortable: false,
          value: "packaging_info_ids",
        },
        {
          text: "Actions",
          align: "right",
          sortable: false,
        },
      ],
    };
  },
  methods: {
    endEdit() {
      if (
        this.editedItem === 0 &&
        this.commercialProducts.length > 0 &&
        !this.commercialProducts[0].id
      )
        this.commercialProducts.shift();
      this.editedItem = -1;
    },
    create() {
      this.sendMutation("created", "product", CREATE_COMMERCIAL_PRODUCT, {
        commercial_zone_id: this.zoneId,
        product_id: this.currentCommercialProduct.product.id,
        packaging_ids: this.currentCommercialProduct.packaging_ids,
        packaging_info_ids: this.currentCommercialProduct.packaging_info_ids,
      }).then((data) => {
        this.commercialProducts.unshift(data.create_commercial_product);
        this.commercialProducts.splice(
          this.commercialProducts.indexOf(
            this.commercialProducts.find((e) => e.id == "")
          ),
          1
        );
        this.endEdit();
      });
    },
    update() {
      this.sendMutation("updated", "product", UPDATE_COMMERCIAL_PRODUCT, {
        id: this.currentCommercialProduct.id,
        product_id: this.currentCommercialProduct.product.id,
        packaging_ids: this.currentCommercialProduct.packaging_ids,
        packaging_info_ids: this.currentCommercialProduct.packaging_info_ids,
      }).then((data) => {
        let cp = this.commercialProducts.find(
          (e) => e.id == this.currentCommercialProduct.id
        );
        cp.packaging_ids = data.update_commercial_product.packaging_ids;
        cp.packaging_info_ids =
          data.update_commercial_product.packaging_info_ids;
        cp.product = data.update_commercial_product.product;
        this.endEdit();
      });
    },
    newProduct() {
      this.currentCommercialProduct = {
        id: "",
        product: {
          id: "",
          name: "",
          product_category_id: "",
          product_category: {
            name: "",
          },
        },
        packaging_ids: [],
        packaging_info_ids: [],
        created_at: new Date("9200-12-12").toISOString().replace("T", " "),
      };
      if (this.commercialProducts.length > 0) {
        let lastCommercialProduct = {
          created_at: "1000",
        };
        let returnMe = null;
        this.commercialProducts.forEach((e) => {
          if (e.id === "") returnMe = true;
          if (e.created_at > lastCommercialProduct.created_at)
            lastCommercialProduct = e;
        });
        if (returnMe) return;
        this.currentCommercialProduct.product.product_category_id =
          lastCommercialProduct.product.product_category_id;
      }
      this.commercialProducts.unshift(this.currentCommercialProduct);
      this.editedItem = 0;
    },

    createOrUpdateCommercialProduct() {
      if (this.currentCommercialProduct.id === "") {
        this.create();
      } else {
        this.update();
      }
    },
    setCurrentCommercialProduct(item) {
      this.currentCommercialProduct = {
        id: item.id,
        product_category_id: item.product.product_category_id,
        product_category: {
          name: item.product.product_category.name,
        },
        product_id: item.product.id,
        product: {
          id: item.product.id,
          name: item.product.name,
          product_category_id: item.product.product_category_id,
        },
        packaging_ids: item.packaging_ids,
        packaging_info_ids: item.packaging_info_ids,
      };
    },

    filteredProducts() {
      let currentProductId = this.currentCommercialProduct.product.id;
      let currentCategoryId = this.currentCommercialProduct.product
        .product_category_id;
      const productIds = this.getCommercialZoneById(this.zoneId)
        .commercial_products.map((e) => {
          return e.product.id;
        })
        .filter((e) => e !== currentProductId);

      return this.categoryProducts(currentCategoryId).filter(
        (e) => !productIds.includes(e.id)
      );
    },
    customSort(items, index, isDescending) {
      items.sort((a, b) => {
        let ret;
        if (index === "0") {
          ret = this.getSort(
            a.product.product_category.name,
            b.product.product_category.name,
            a.product.name,
            b.product.name
          );
        } else if (index === "1") {
          ret = this.getSort(
            a.product.name,
            b.product.name,
            a.created_at,
            b.created_at
          );
        } else {
          ret = this.getSort(
            a.created_at,
            b.created_at,
            a.created_at,
            b.created_at
          );
        }
        return isDescending ? -ret : ret;
      });
      return items;
    },
    edit(index, product) {
      if (this.editedItem !== index) {
        if (this.editedItem >= 0) {
          this.endEdit();
        } else {
          this.editedItem = index;
          this.setCurrentCommercialProduct(product);
        }
      }
    },
  },

  computed: {
    ...mapGetters("commercialStore", ["getCommercialZoneById"]),
    ...mapGetters("commonStore", [
      "product_categories",
      "packaging_infos",
      "packagings",
      "products",
      "categoryProducts",
      "getNameById",
    ]),
    commercialProducts() {
      return this.getCommercialZoneById(this.zoneId).commercial_products;
    },
  },
  watch: {
    zoneId() {
      this.editedItem = -1;
    },
  },
};
</script>

<style lang="stylus" scoped>
.small-font {
  font-size: small;
}

.min-width-action {
  min-width: 100px;
}

.min-width-column {
  min-width: 18em;
}

.clickable {
  cursor: pointer;
}
</style>
<style>
.bordered > .v-toolbar__content {
  border: 1px solid rgba(0, 0, 0, 0.12);
}

.small-font input {
  padding: 5px;
}

.small-font .v-select__selection--comma {
  margin-left: 5px;
}
</style>
